@if (ready) {
  <div class="">
    <!-- <h1 class="h1-xs">{{validatedTool.tool.name.displayName}}
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
  </h1> -->

    <!-- warning title -->
    <!-- <div class="alert alert-warning text-center p-1 mb-0" [class.invisible]="!showWarning">
    <i class="fas fa-fw fa-exclamation-circle"></i> {{ warningText }}
  </div> -->

    <!-- parameters -->
    <div class="row">
      <div class="col">
        <!-- <h2 class="h2-xs mt-1 mb-2">Computing resources</h2> -->
      </div>

      <div class="col">
        @if (isResetAllVisible()) {
          <button class="btn btn-sm btn-outline-secondary me-1 mb-2 float-end" (click)="resetAll()" title="Reset all">
            <span class="fas fa-fw fa-undo text-primary" aria-hidden="true"></span>
            Reset all
          </button>
        }
        @if (!isResetAllVisible()) {
          <button
            class="btn btn-sm btn-outline-secondary me-1 mb-2 float-end"
            (click)="resetAll()"
            title="Reset all"
            [disabled]="true">
            <span class="fas fa-fw fa-undo" aria-hidden="true"></span>
            Reset all
          </button>
        }
      </div>
    </div>

    @if (validatedTool.tool) {
      <form name="paramForm">
        <table class="table table-sm">
          <tbody>
            @for (id of keys(resources); track id; let isLast = $last) {
              <tr>
                <td style="width: 60%" [class.no-bottom-border]="isLast">
                  <!-- parameter name -->
                  {{ resources[id].title }}

                  <!-- parameter description -->
                  <div class="text-sm text-muted">
                    {{ resources[id].description }}
                  </div>
                </td>

                <!-- parameter value -->

                <td [class.no-bottom-border]="isLast">
                  <!-- number -->
                  <input
                    class="w-100"
                    type="number"
                    [(ngModel)]="resources[id].value"
                    name="{{ id }}"
                    min="{{ resources[id].min }}"
                    max="{{ resources[id].max }}"
                    step="{{ resources[id].step }}"
                    required="false"
                    (ngModelChange)="onResourceChanged(id)" />

                  <!-- validation message -->
                  @if (!getResourceValidation(id).valid) {
                    <div class="alert alert-warning p-1 mb-0 mt-1 text-sm">
                      {{ getResourceValidation(id).message }}
                    </div>
                  }
                </td>

                <!-- buttons -->
                <td [class.no-bottom-border]="isLast">
                  <!-- reset to default -->
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-dark btn-no-border float-end"
                    [class.invisible]="!isResetVisible(id)"
                    (click)="reset(id)"
                    title="Reset to default">
                    <i class="fas fa-undo text-primary"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </form>
    }
  </div>
}
